import { MyMedicApp } from "../../../api/mymedic.types";
import { MyMedicAppAction } from "./mymedic.app.types";

export const myMedicAppRequestAction = (): MyMedicAppAction => ({ type: 'MYMEDIC_APP_REQUEST' })
export const myMedicAppSuccessAction = (app: MyMedicApp): MyMedicAppAction => ({ type: 'MYMEDIC_APP_SUCCESS', params: app })
export const myMedicAppFailureAction = (error?: any): MyMedicAppAction => ({ type: 'MYMEDIC_APP_FAILURE', params: error })